import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

declare module 'vue-router' {
  interface RouteMeta {
    title?: string
    /** Slug документа для LegalDocView. */
    legalSlug?: string
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: { title: 'AvoSchool - онлайн-занятия с репетитором' },
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('@/views/BlogListView.vue'),
    meta: { title: 'Блог AvoSchool' },
  },
  {
    path: '/blog/:slug',
    name: 'blog-post',
    component: () => import('@/views/BlogPostView.vue'),
    meta: { title: 'Блог AvoSchool' },
  },
  {
    path: '/sveden',
    name: 'sveden',
    component: () => import('@/views/SvedenView.vue'),
    meta: { title: 'Сведения об организации - AvoSchool' },
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('@/views/LegalDocView.vue'),
    meta: { title: 'Политика конфиденциальности - AvoSchool', legalSlug: 'policy' },
  },
  {
    path: '/oferta',
    name: 'oferta',
    component: () => import('@/views/LegalDocView.vue'),
    meta: { title: 'Публичная оферта - AvoSchool', legalSlug: 'oferta' },
  },
  {
    path: '/licence',
    name: 'licence',
    component: () => import('@/views/LicenceView.vue'),
    meta: { title: 'Образовательная лицензия - AvoSchool' },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, top: 84, behavior: 'smooth' }
    }
    return { top: 0 }
  },
})

router.afterEach((to) => {
  const title = to.meta.title
  if (typeof title === 'string') {
    document.title = title
  }
})
